import type { RelatedLink } from '@/lib/relatedContent';

/**
 * Picks a topical illustrated icon for an internal-link card, so related
 * content, pricing and landing links never fall back to a generic arrow.
 * Icons are the Pixelcut tile set in /public/images/icons.
 */
const R = (n: string) => `/images/icons/related/${n}.webp`;
const S = (n: string) => `/images/icons/services/${n}.webp`;
const M = (n: string) => `/images/icons/managed/${n}.webp`;

const TOPICS: [RegExp, string][] = [
  [/governance|responsible ai|ethic|ai policy/, S('ai-governance')],
  [/copilot/, S('ai-copilot')],
  [/agent|automat|rpa|workflow/, R('automation')],
  [/generative|genai|llm|chatbot|assistant/, S('ai-assistant')],
  [/business intelligence|analytics|\bbi\b|dashboard|report|data/, R('analytics')],
  [/\bai\b|machine learning|artificial/, S('ai-data')],
  [/ransom|phish/, M('ransomware')],
  [/secur|cyber|zero trust|mfa|threat/, R('cybersecurity')],
  [/complian|audit|cjis|hipaa|nist/, S('compliance-audit')],
  [/backup|disaster|continuity/, M('no-backup')],
  [/payroll support|year-end/, S('erp-calendar')],
  [/infor|workday|lawson|cloudsuite|erp|peoplesoft|oracle|hcm/, R('erp-system')],
  [/cloud|azure|\baws\b|migrat/, R('cloud-migration')],
  [/network|infrastructure|server/, R('network')],
  [/service desk|help desk|helpdesk|support desk/, M('help-desk')],
  [/healthcare|ehr|hospital|clinical/, R('healthcare-it')],
  [/contract-to-hire|direct hire|direct-hire/, S('staff-direct')],
  [/staff|consultant|talent|hiring|recruit/, R('request-consultant')],
  [/integration|api/, S('dev-integration')],
  [/software|develop|app|web/, R('app-development')],
  [/strategy|advisory|roadmap|transformation|assessment/, R('strategy-roadmap')],
  [/\bteams?\b/, R('team-backing')],
  [/training|academy|learn/, R('training')],
  [/government|cities|counties|municipal|police|district|public sector/, S('government-staff')],
  [/dallas|dfw|fort worth|texas/, R('service-area')],
  [/managed|outsourc|co-managed|microsoft 365/, M('always-on')],
];

export function relatedIcon(l: RelatedLink): string {
  const to = l.to.toLowerCase();
  if (to.startsWith('/videos')) return R('how-to-video');
  if (to.endsWith('/pricing') || /pricing|calculator|cost/.test(l.label.toLowerCase())) return R('pricing-calculator');
  const text = `${l.label} ${to}`.toLowerCase();
  for (const [re, icon] of TOPICS) if (re.test(text)) return icon;
  return to.startsWith('/insights') ? R('insight-article') : R('strategy-roadmap');
}

export const RELATED_ICON = R;
